<!-- 定制菜单（乐乐专属） -->
<template>
  <div>
    <!-- 抽奖 -->
    <div
      class="side-menu"
      :class="{ disable: !hasLotteryAuth, selected: selectKind == 'lottery' }"
      @click="handleClick('lottery', { disable: !hasLotteryAuth })"
      v-if="hasLotteryAuth"
    >
      <i class="vh-iconfont vh-a-line-luckydraw"></i>
      <span class="text">{{ $t('interact_tools.interact_tools_1003') }}</span>
    </div>

    <!-- 快问快答 -->
    <div
      class="side-menu"
      :class="{ disable: !hasExamAuth, selected: selectKind == 'exam' }"
      @click="handleClick('exam', { disable: !hasExamAuth })"
      v-if="hasExamAuth"
    >
      <i class="vh-iconfont vh-a-line-Sentaanswer"></i>
      <span class="text">{{ $t('exam.exam_1047') }}</span>
    </div>

    <!-- 签到 -->
    <div
      class="side-menu"
      :class="{ disable: !hasSigninAuth, selected: selectKind == 'sign' }"
      @click="handleClick('sign', { disable: !hasSigninAuth })"
      v-if="hasSigninAuth"
    >
      <i class="vh-iconfont vh-line-order"></i>
      <span class="text">{{ $t('interact_tools.interact_tools_1024') }}</span>
    </div>

    <!-- 打卡 -->
    <!-- 20250908 打卡功能下线 -->
    <!-- <div
    class="side-menu"
    :class="{ disable: !hasPunchAuth, selected: selectKind == 'punch' }"
    @click="handleClick('punch', { disable: !hasPunchAuth })"
    v-if="hasPunchAuth"
  >
    <i class="vh-iconfont vh-line-ticket1"></i>
    <span class="text">打卡</span>
  </div> -->

    <!-- 观看有礼 -->
    <div
      class="side-menu"
      :class="{ disable: !hasWatchGiftAuth, selected: selectKind == 'watchgift' }"
      @click="handleClick('watchgift', { disable: !hasWatchGiftAuth })"
      v-if="hasWatchGiftAuth"
    >
      <i class="vh-iconfont vh-guankanyouli"></i>
      <span class="text">{{ $t('interact_tools.interact_tools_1151') }}</span>
    </div>

    <!-- 商城奖励 -->
    <div
      class="side-menu"
      :class="{ disable: !hasMallRewardAuth, selected: selectKind == 'mallreward' }"
      @click="handleClick('mallreward', { disable: !hasMallRewardAuth })"
      v-if="hasMallRewardAuth"
    >
      <i class="vh-iconfont vh-a-line-mallreward"></i>
      <span class="text">{{ $t('interact_tools.interact_tools_1156') }}</span>
    </div>

    <!-- 踢出直播 -->
    <div
      class="side-menu"
      :class="{ disable: !hasInactiveKickAuth, selected: selectKind == 'inactive_kick' }"
      @click="handleClick('inactive_kick', { disable: !hasInactiveKickAuth })"
      v-if="hasInactiveKickAuth"
    >
      <i class="vh-saas-iconfont vh-saas-line-blacklist"></i>
      <span class="text">{{ $t('host.k_501001') }}</span>
    </div>

    <!-- 分享 -->
    <div class="side-menu menu-footer" @click="handleClick('share')" v-if="hasShareAuth">
      <i class="vh-iconfont vh-line-share"></i>
      <span class="text">{{ $t('aside_menu.aside_menu_1006') }}</span>
    </div>

    <VmpLotteryLive v-if="hasLotteryAuth"></VmpLotteryLive>
    <VmpExam v-if="hasExamAuth"></VmpExam>
  </div>
</template>
<script>
  import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter.js';

  export default {
    name: 'AsideMenu2',
    data() {
      return {
        // 当前在中间内容区打开的功能，对话框模式的功能不算
        selectKind: ''
      };
    },
    computed: {
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      configList() {
        let configList = this.$domainStore.state.roomBaseServer.configList;
        return configList;
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      },
      // 是否在直播中
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      },
      // 是否抽奖功能权限
      hasLotteryAuth() {
        return (
          [1, 3, 4].includes(this.roleName) && this.configList['ui.hide_lottery'] && !this.auth_gd
        );
      },
      // 是否有签到功能权限
      hasSigninAuth() {
        return (
          [1, 3, 4].includes(this.roleName) && this.configList['ui.hide_sign_in'] && !this.auth_gd
        );
      },
      // 是否有打卡功能权限
      hasPunchAuth() {
        // TODO: admin目前没有配置相应的权限
        return [1, 3, 4].includes(this.roleName) && !this.auth_gd;
      },
      // 是否有快问快答功能权限
      hasExamAuth() {
        return [1, 3, 4].includes(this.roleName) && this.configList['exam'] && !this.auth_gd;
      },
      // 是否有观看有礼功能权限
      hasWatchGiftAuth() {
        return [1, 3, 4].includes(this.roleName) && this.configList['watch_gift'] && !this.auth_gd;
      },
      // 是否有商城奖励的权限
      hasMallRewardAuth() {
        return [1, 3, 4].includes(this.roleName) && this.configList['mall_reward'] && !this.auth_gd;
      },
      // 是否有未互动踢出直播间功能权限
      hasInactiveKickAuth() {
        return (
          [1, 3, 4].includes(this.roleName) && this.configList['inactive_kick'] && !this.auth_gd
        );
      },
      // 是否有分享功能权限
      hasShareAuth() {
        // prettier-ignore
        return [1, 3, 4].includes(this.roleName) && this.configList['ui.hide_share'] && !this.auth_gd;
      },
      // 是否正在三方推流
      isThirdStream() {
        return this.$domainStore.state.roomBaseServer.isThirdStream;
      }
    },
    methods: {
      handleClick(kind, options) {
        if (options?.disable) return;
        emitter.emit(EMIT_DEFINE.live_sidemenu_change, { kind });
      },
      sidemenuStatusChange({ kind }) {
        this.selectKind = kind ? kind : '';
      }
    },
    created() {
      emitter.on(EMIT_DEFINE.live_sidemenu_change, this.sidemenuStatusChange);
    },
    beforeDestroy() {
      emitter.off(EMIT_DEFINE.live_sidemenu_change, this.sidemenuStatusChange);
    }
  };
</script>
<style lang="less">
  .side-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #ececec;
    padding: 10px 0px;
    cursor: pointer;

    span.text {
      font-size: 12px;
      user-select: none;
      text-align: center;
    }
    i {
      user-select: none;
      display: block;
      width: 23px;
      height: 23px;
      margin: 0 auto;
      padding-bottom: 6px;
      font-size: 22px;
    }

    &.selected {
      span.text,
      i {
        color: #fb3a32;
      }
    }

    &.disable {
      cursor: not-allowed;
      span.text,
      i {
        color: #777777;
      }
    }

    &.menu-footer {
      position: absolute;
      width: 100%;
      bottom: 10px;
    }
  }
</style>
